import { render, staticRenderFns } from "./ExpansionTab.vue?vue&type=template&id=7ce9620e&scoped=true&lang=pug&"
import script from "./ExpansionTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpansionTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpansionTab.vue?vue&type=style&index=0&id=7ce9620e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9620e",
  null
  
)

export default component.exports